/**
 * @generated SignedSource<<f146a1f79dbd635b45ccac72c3d52af9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpTabs_nftItem$data = {
  readonly creatorAddress: {
    readonly address: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpHistory_nftItem" | "NftPdpOwners_nftItem">;
  readonly " $fragmentType": "NftPdpTabs_nftItem";
};
export type NftPdpTabs_nftItem$key = {
  readonly " $data"?: NftPdpTabs_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpTabs_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpTabs_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "address",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpOwners_nftItem"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpHistory_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "a1f2071a58ac9c1a561f961aa7e91b21";

export default node;
